/*
 * WarisAds Messages
 *
 * This contains all the text for the WarisAds component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.containers.WarisAds.header',
    defaultMessage: 'Apa Anda berhak mendapat hak waris?',
  },
  description: {
    id: 'app.containers.WarisAds.description',
    defaultMessage: 'Konsultan hukum waris berpengalaman siap menjawab.',
  },
  cta: {
    id: 'app.containers.WarisAds.cta',
    defaultMessage: 'Cek Hak Anda Sekarang'
  },
});
